import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { H6, Spinner } from '../../../../AbstractElements';
import { useSelector } from 'react-redux';
import AdminPermission from '../../../../Component/Admin/Admin/DetailAdmin/AdminPermission';

const DetailTentor = () => {

    return (
        <Fragment>
            <Container fluid={true}>
                <div>
                    <Row className="product-page-main p-0">
                        <AdminPermission />
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};

export default DetailTentor;